import { createBrowserHistory } from 'history';

/**
 * 沙雕history5.0不兼容于4.0，router 4/5必须对应4.X
 */
export const historyInstance = createBrowserHistory();